/* eslint-disable react/prop-types */
import React, { useMemo } from 'react'
import { IconButton } from '@mui/material'
import {
  VolumeUp,
  VolumeOff,
  Logout,
  PushPin,
  Fullscreen,
  FullscreenExit,
  DragIndicator,
} from '@mui/icons-material'

import { CtrlAltDelIcon } from './icons/CtrlAltDelIcon'
import { PointerLockIcon } from './icons/PointerLockIcon'

export function ToolbarButton({
  active = false,
  disabled = false,
  title,
  className = '',
  icon,
  onClick = () => null,
  ...rest
}) {
  const renderIcon = useMemo(() => {
    switch (icon) {
      case 'DragIndicator':
        return <DragIndicator />
      case 'VolumeUp':
        return <VolumeUp />
      case 'VolumeOff':
        return <VolumeOff />
      case 'PushPin':
        return <PushPin />
      case 'Fullscreen':
        return <Fullscreen />
      case 'FullscreenExit':
        return <FullscreenExit />
      case 'ctrlAltDel':
        return <CtrlAltDelIcon />
      case 'pointerLock':
        return <PointerLockIcon />
      default:
        return <Logout />
    }
  }, [icon])

  return (
    <div
      className={className}
      id={!active ? '' : 'active'}
      style={
        icon === 'DragIndicator'
          ? { borderRight: '1px solid #e6e6e6' }
          : {
              border: active && !disabled ? '1px solid #027aae' : '1px solid #e6e6e6',
              borderRadius: '5px',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }
      }
    >
      <IconButton
        size="small"
        style={{ borderRadius: '5px', width: '25px', height: '25px', opacity: disabled ? 0.5 : 1 }}
        id={!active ? '' : 'button'}
        onClick={onClick}
        disabled={disabled}
        disableRipple
        title={title}
        data-testid={rest['data-testid']}
      >
        {renderIcon}
      </IconButton>
    </div>
  )
}
